
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.679 6.017c0-.37.3-.669.668-.669h5.349a.669.669 0 010 1.337H5.347c-.369 0-.668-.3-.668-.668zM4.679 8.69c0-.368.3-.668.668-.668h2.675a.669.669 0 110 1.337H5.347c-.369 0-.668-.299-.668-.668z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.492 11.675c.24-.2.543-.31.856-.31H12.7c.37 0 .669-.3.669-.669V4.011c0-.37-.3-.669-.668-.669h-9.36c-.369 0-.668.3-.668.669v9.179l1.818-1.515zm.856 1.027H12.7a2.006 2.006 0 002.006-2.006V4.011a2.006 2.006 0 00-2.006-2.006H3.342a2.006 2.006 0 00-2.005 2.006v9.179c0 1.133 1.322 1.753 2.193 1.027l1.818-1.515z","fill":"currentColor"}})])
          )
        }
      }
    